import React from 'react';

import { FlexProps, Flex } from '@opendoor/bricks/core';

/**
 * TODO: Add documentation
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const DisplayCard: React.FC<FlexProps> = ({ children, ...props }) => (
  <Flex
    justifyContent="space-between"
    boxSizing="border-box"
    borderTopRightRadius="roundedSquare"
    borderBottomRightRadius="roundedSquare"
    {...props}
  >
    {children}
  </Flex>
);
